module.exports = __webpack_public_path__ + "img/US_DamageOverTime_ua.b144f5a2.webp";